export function popupCarousel(html, numImages) {
    if ($('#popup-carousel').length) {
        $('#popup-carousel').remove();
    }
    let dialog =
        "<div id='popup-carousel' class='modal fade popup-carousel' tabindex='-1'>" +
        "<div class='modal-dialog'>" +
        "<div class='modal-content'>" +
        "<button type='button' class='close' data-dismiss='modal' aria-hidden='true' style='position: absolute;right: 5px;z-index: 1;font-size: 25px;'>×</button>" +
        "<div class='modal-body'><div id='images-carousel'>" +
        html +
        "</div></div></div></div></div>";
    $(dialog).modal();
    setTimeout(function() {
        $('#images-carousel').slick(
            {
                infinite: true,
                lazyLoad: 'progressive',
                prevArrow: '<div class="img-carousel-nav img-carousel-prev"><span class="glyphicon glyphicon-menu-left"></span></div>',
                nextArrow: '<div class="img-carousel-nav img-carousel-next"><span class="glyphicon glyphicon-menu-right"></span></div>',
                slidesToShow: 1,
                //variableWidth: true,
                centerMode: false,
                adaptiveHeight: numImages > 1,
                arrows: true
            }
        );
        $('#images-carousel').on('lazyLoaded', function(event, slick, image, imageSource) {
            $("<img/>",{
                load : function(){
                    let parentHeight = $('.modal-backdrop.fade.in').height();
                    if (this.height > this.width) {
                        let height = parentHeight * 0.90;
                        $(image).addClass('vertical');
                        $(image).parents('div').first().css({'height':height+'px'});
                    }
                },
                src  : imageSource
            });
        });
    }, 150);
}